export const PROFILE = {
  name: "Isai Coria",
  cvUrl: "/cv-isai-coria.pdf",
  whatsapp: "527441987416",
  email: "isai.coria@divelopers.digital",
};

export const UI = {
  es: {
    hello: "// hola, soy",
    intro:
      "Diseño y construyo sistemas backend robustos, escalables y seguros: APIs de alto tráfico, integraciones B2B y automatización financiera para empresas que no pueden fallar.",
    cv: "Descargar CV",
    wa: "Contactar por WhatsApp",
    waMsg: "Hola Isai, vi tu portafolio y me interesa platicar sobre un proyecto.",
    location: "México · Remoto",
    terminalIdle: '$ Presiona "Send" para consultar mi perfil',
    terminalLoading: "→ Enviando request…",
    skillsTitle: "Habilidades clave",
    projectsTitle: "Proyectos Enterprise",
    archShow: "Ver arquitectura",
    archHide: "Ocultar arquitectura",
    flowTab: "Diagrama de flujo",
    layersTab: "Capas técnicas",
    back: "Ver agencia",
    form: {
      title: "¿Tienes una oportunidad?",
      subtitle: "Cuéntame sobre tu empresa o proyecto y te respondo en menos de 24 horas.",
      name: "Nombre *",
      company: "Empresa",
      email: "Email *",
      opportunity: "Tipo de oportunidad (opcional)",
      opts: { job: "Empleo", freelance: "Freelance", consulting: "Consultoría" },
      message: "Mensaje *",
      submit: "Enviar mensaje",
      success: "¡Mensaje enviado! Te responderé pronto.",
      error: "No se pudo enviar. Revisa tus datos e inténtalo de nuevo.",
      another: "Enviar otro",
    },
  },
  en: {
    hello: "// hi, I'm",
    intro:
      "I design and build robust, scalable and secure backend systems: high-traffic APIs, B2B integrations and financial automation for companies that can't afford to fail.",
    cv: "Download CV",
    wa: "Contact on WhatsApp",
    waMsg: "Hi Isai, I saw your portfolio and I'd like to talk about a project.",
    location: "Mexico · Remote",
    terminalIdle: '$ Press "Send" to fetch my profile',
    terminalLoading: "→ Sending request…",
    skillsTitle: "Key skills",
    projectsTitle: "Enterprise Projects",
    archShow: "View architecture",
    archHide: "Hide architecture",
    flowTab: "Flow diagram",
    layersTab: "Technical layers",
    back: "View agency",
    form: {
      title: "Have an opportunity?",
      subtitle: "Tell me about your company or project and I'll reply within 24 hours.",
      name: "Name *",
      company: "Company",
      email: "Email *",
      opportunity: "Opportunity type (optional)",
      opts: { job: "Full-time job", freelance: "Freelance", consulting: "Consulting" },
      message: "Message *",
      submit: "Send message",
      success: "Message sent! I'll get back to you soon.",
      error: "Couldn't send it. Check your details and try again.",
      another: "Send another",
    },
  },
};

export const apiResponse = (lang) => ({
  status: "success",
  data: {
    name: PROFILE.name,
    role: "Senior Java / Backend Developer",
    location: UI[lang].location,
    experience_years: 8,
    core_stack: ["Java 21", "Spring Boot 3", "Microservices", "PostgreSQL", "Kafka"],
    cloud: ["AWS", "Docker", "Kubernetes"],
    focus:
      lang === "es"
        ? ["APIs REST de alto tráfico", "Integraciones B2B", "Automatización financiera"]
        : ["High-traffic REST APIs", "B2B integrations", "Financial automation"],
    available_for: ["Tech Lead", "B2B Solutions"],
    open_to_work: true,
  },
});

export const SKILLS = [
  { group: { es: "Lenguajes", en: "Languages" }, items: ["Java 21", "Kotlin", "Python", "SQL", "TypeScript"] },
  { group: { es: "Frameworks", en: "Frameworks" }, items: ["Spring Boot", "Spring Cloud", "Hibernate / JPA", "Quarkus", "FastAPI"] },
  { group: { es: "Datos & Mensajería", en: "Data & Messaging" }, items: ["PostgreSQL", "Oracle", "MongoDB", "Redis", "Kafka", "RabbitMQ"] },
  { group: { es: "Cloud & DevOps", en: "Cloud & DevOps" }, items: ["AWS", "Docker", "Kubernetes", "GitHub Actions", "Terraform"] },
  { group: { es: "Arquitectura", en: "Architecture" }, items: ["Microservicios", "Event-Driven", "DDD", "Hexagonal", "CQRS"] },
  { group: { es: "Calidad", en: "Quality" }, items: ["JUnit 5", "Mockito", "Testcontainers", "SonarQube", "Observability"] },
];

export const PROJECTS = [
  {
    id: "b2b-engine",
    tag: { es: "B2B · Plataforma", en: "B2B · Platform" },
    title: { es: "Divelopers B2B Engine", en: "Divelopers B2B Engine" },
    description: {
      es: "Motor de cotización y gestión de leads para negocios locales: API REST, autenticación JWT, notificaciones transaccionales y panel administrativo en tiempo real.",
      en: "Quoting and lead-management engine for local businesses: REST API, JWT authentication, transactional notifications and a real-time admin dashboard.",
    },
    stack: ["Java", "Spring Boot", "PostgreSQL", "Docker", "REST"],
    metrics: [
      { label: { es: "Latencia p95", en: "p95 latency" }, value: "<120ms" },
      { label: { es: "Uptime", en: "Uptime" }, value: "99.9%" },
    ],
    flow: [
      { label: "Web / React SPA", sub: { es: "Cotizador y panel admin", en: "Quoter & admin panel" } },
      { label: "API Gateway", sub: { es: "JWT · rate limiting", en: "JWT · rate limiting" } },
      { label: "Quote Service", sub: { es: "Spring Boot · reglas de precio", en: "Spring Boot · pricing rules" } },
      { label: "Notification Service", sub: { es: "Emails transaccionales", en: "Transactional emails" } },
      { label: "PostgreSQL", sub: { es: "Leads · índices", en: "Leads · indexes" } },
    ],
    layers: [
      { name: { es: "Presentación", en: "Presentation" }, items: ["React", "Tailwind", "REST client"] },
      { name: { es: "API / Seguridad", en: "API / Security" }, items: ["Spring Security", "JWT", "Bcrypt"] },
      { name: { es: "Dominio", en: "Domain" }, items: ["Quote", "Lead", "PricingPolicy"] },
      { name: { es: "Infraestructura", en: "Infrastructure" }, items: ["PostgreSQL", "Resend", "Docker"] },
    ],
  },
  {
    id: "bank-sat",
    tag: { es: "Fintech · Automatización", en: "Fintech · Automation" },
    title: { es: "Conciliación Automática Banco vs. SAT", en: "Automated Bank vs. SAT Reconciliation" },
    description: {
      es: "Servicio que cruza estados de cuenta bancarios contra CFDI del SAT, detecta discrepancias y genera reportes contables automáticamente, eliminando horas de trabajo manual.",
      en: "Service that matches bank statements against SAT CFDI invoices, detects discrepancies and generates accounting reports automatically, eliminating hours of manual work.",
    },
    stack: ["Java 21", "Spring Batch", "Kafka", "Oracle", "AWS"],
    metrics: [
      { label: { es: "Registros/día", en: "Records/day" }, value: "500K+" },
      { label: { es: "Ahorro manual", en: "Manual work" }, value: "-90%" },
    ],
    flow: [
      { label: "Bank Statements", sub: { es: "SFTP · CSV / MT940", en: "SFTP · CSV / MT940" } },
      { label: "SAT CFDI", sub: { es: "Descarga masiva XML", en: "Bulk XML download" } },
      { label: "Kafka", sub: { es: "Ingesta de eventos", en: "Event ingestion" } },
      { label: "Reconciliation Engine", sub: { es: "Spring Batch · matching", en: "Spring Batch · matching" } },
      { label: "Oracle + S3", sub: { es: "Reportes contables", en: "Accounting reports" } },
    ],
    layers: [
      { name: { es: "Ingesta", en: "Ingestion" }, items: ["SFTP", "SAT WS", "Kafka Connect"] },
      { name: { es: "Procesamiento", en: "Processing" }, items: ["Spring Batch", "Matching rules", "Retries"] },
      { name: { es: "Persistencia", en: "Persistence" }, items: ["Oracle", "S3", "Redis cache"] },
      { name: { es: "Observabilidad", en: "Observability" }, items: ["Prometheus", "Grafana", "Alerts"] },
    ],
  },
];
